var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "dm1" }, [
        _c("div", [
          _c("span", { staticClass: "dm1_title" }, [
            _vm._v(_vm._s(_vm.$t("collectionCenter.deliveryMonitor"))),
          ]),
          _c("br"),
          _c("span", { staticClass: "dm1_msg" }, [
            _vm._v(_vm._s(_vm.$t("collectionCenter.deliveryFailureStats"))),
          ]),
        ]),
        _c("span", { staticClass: "dm1_time" }, [
          _vm._v(
            _vm._s(
              _vm.updateTime
                ? _vm.$t("customerManagements.dataUpdateTime") +
                    "：" +
                    _vm.updateTime
                : ""
            )
          ),
        ]),
      ]),
      _c(
        "el-card",
        [
          _c(
            "el-form",
            { attrs: { model: _vm.queryForm, size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.latestFailTime"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "-",
                              "default-time": ["00:00:00", "23:59:59"],
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "end-placeholder": _vm.$t(
                                "collectionCenter.EndTime"
                              ),
                              "start-placeholder": _vm.$t(
                                "collectionCenter.StartTime"
                              ),
                              clearable: false,
                            },
                            on: { change: _vm.dateChange },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "border_none",
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                              },
                              on: { change: _vm.changeNum },
                              model: {
                                value: _vm.selectNum,
                                callback: function ($$v) {
                                  _vm.selectNum = $$v
                                },
                                expression: "selectNum",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("newOrder.waybillNumber"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.ScanNumber"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.max2000Line"
                              ),
                              clearable: "",
                              type: "textarea",
                              rows: 1,
                            },
                            on: { blur: _vm.BlockNewNumber },
                            nativeOn: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.BlockNewNumber($event)
                              },
                            },
                            model: {
                              value: _vm.orderNumber,
                              callback: function ($$v) {
                                _vm.orderNumber = $$v
                              },
                              expression: "orderNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("placeOrder.client") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("collectionCenter.tudo"),
                                "remote-method": _vm.getCustomerPage,
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: {
                                change: _vm.changeCustomer,
                                clear: function ($event) {
                                  return _vm.getCustomerPage("")
                                },
                                focus: function ($event) {
                                  return _vm.getCustomerPage("", true)
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.customerIdList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerIdList",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.customerIdList",
                              },
                            },
                            _vm._l(_vm.customerIdData, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.username, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.CommercialOwner"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("collectionCenter.tudo"),
                                "remote-method": _vm.remoteMethod,
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: {
                                clear: function ($event) {
                                  return _vm.remoteMethod("")
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.merchantCodeList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "merchantCodeList",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.merchantCodeList",
                              },
                            },
                            _vm._l(_vm.merchantData, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "32px" },
                      attrs: { span: 4 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "medium", type: "primary" },
                          on: { click: _vm.searchForm },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "medium" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "package_box" },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", [
                _c(
                  "div",
                  { staticStyle: { "font-size": "14px", color: "#6b7280" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.failedDeliveryCount"))
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "25px",
                      "font-weight": "700",
                      color: "#111827",
                    },
                  },
                  [_vm._v(_vm._s(_vm.packageList.totalCount))]
                ),
                _c(
                  "div",
                  { staticStyle: { "font-size": "12px", color: "#9ca3af" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.totalPackagesFiltered"))
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", [
                _c(
                  "div",
                  { staticStyle: { "font-size": "14px", color: "#6b7280" } },
                  [_vm._v(_vm._s(_vm.$t("collectionCenter.multiFailPackages")))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "25px",
                      "font-weight": "700",
                      color: "#111827",
                    },
                  },
                  [_vm._v(_vm._s(_vm.packageList.twoFailureCount))]
                ),
                _c(
                  "div",
                  { staticStyle: { "font-size": "12px", color: "#9ca3af" } },
                  [_vm._v(_vm._s(_vm.$t("collectionCenter.failCountGe2")))]
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", [
                _c(
                  "div",
                  { staticStyle: { "font-size": "14px", color: "#6b7280" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.multiFailPackages3Plus"))
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "25px",
                      "font-weight": "700",
                      color: "#111827",
                    },
                  },
                  [_vm._v(_vm._s(_vm.packageList.threeFailureCount))]
                ),
                _c(
                  "div",
                  { staticStyle: { "font-size": "12px", color: "#9ca3af" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.qualityControlFocus"))
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", [
                _c(
                  "div",
                  { staticStyle: { "font-size": "14px", color: "#6b7280" } },
                  [_vm._v(_vm._s(_vm.$t("collectionCenter.avgRetryInterval")))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "25px",
                      "font-weight": "700",
                      color: "#111827",
                    },
                  },
                  [_vm._v(_vm._s(_vm.packageList.averageInterval))]
                ),
                _c(
                  "div",
                  { staticStyle: { "font-size": "12px", color: "#9ca3af" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.adjacentFailInterval"))
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "margin-bottom": "10px",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "16px",
                    "font-weight": "600",
                    color: "#111827",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.deliveryFailDetails")))]
              ),
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium" },
                      on: { click: _vm.batchExportOpen },
                    },
                    [_vm._v(_vm._s(_vm.$t("placeOrder.BatchExport")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "primary" },
                      on: { click: _vm.exportAll },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.export")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": {
                  background: "#f2f2f2",
                  color: "black",
                  textAlign: "center",
                },
                "max-height": "500",
              },
            },
            _vm._l(_vm.tableHeaderList, function (item) {
              return _c("el-table-column", {
                key: item.prop,
                attrs: {
                  prop: item.prop,
                  label: item.label,
                  width: item.cloWidth,
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          item.prop === "waybillNumber"
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    color: "#2563eb",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(scope.row[item.prop]) + " "
                                  ),
                                ]
                              )
                            : item.prop === "secondTimeIntervalStr" ||
                              item.prop === "firstTimeIntervalStr"
                            ? _c("div", [
                                scope.row[item.prop]
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#7c3aed",
                                          "font-weight": "bold",
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row[item.prop]))]
                                    )
                                  : _c("span", [_vm._v("--")]),
                              ])
                            : _c("div", [
                                _vm._v(_vm._s(scope.row[item.prop] || "--")),
                              ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100, 500, 1000],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getTableData,
                  "size-change": function ($event) {
                    return _vm.getTableData(1)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.openShow,
            title: _vm.$t("placeOrder.BatchExport"),
            "close-on-click-modal": false,
            "close-on-click-outside": false,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.openShow = $event
            },
            close: _vm.closeBatchExport,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "batchExport_box",
              staticStyle: { padding: "20px" },
            },
            [
              _c(
                "el-form",
                {
                  ref: "batchExportRef",
                  attrs: { model: _vm.beForm, "label-width": "100px" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        rules: [
                          {
                            required: true,
                            message: _vm.$t("collectionCenter.notNull"),
                          },
                        ],
                        prop: "orderNumber",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.changeExportType },
                          model: {
                            value: _vm.beForm.exportType,
                            callback: function ($$v) {
                              _vm.$set(_vm.beForm, "exportType", $$v)
                            },
                            expression: "beForm.exportType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.waybillNumber"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.ScanNumber"),
                              value: 2,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("br"),
                      _c("el-input", {
                        staticStyle: { width: "100%", "margin-top": "5px" },
                        attrs: {
                          placeholder: _vm.$t("collectionCenter.max2000Line"),
                          clearable: "",
                          type: "textarea",
                          rows: 5,
                        },
                        on: { blur: _vm.BlockNewBatchExport },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.BlockNewBatchExport($event)
                          },
                        },
                        model: {
                          value: _vm.beForm.orderNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.beForm, "orderNumber", $$v)
                          },
                          expression: "beForm.orderNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.closeBatchExport } }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.cancel"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.BatchExport } },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.CheckItOutNow")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }